// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"101":"component---src-templates-home-js","202":"component---src-templates-list-js"}[chunkId] + "-" + {"101":"cdde9b7803980a95e855","202":"78ee61f1087e9c5cf21d"}[chunkId] + ".js";
};